$(() => {
  // ハンバーガー
  $('.gnav__btn a').on('click', function () {
    if ($(this).hasClass('onClick')) {
      $(this).removeClass('onClick').addClass('removeClick')
    } else {
      $(this).removeClass('removeClick').addClass('onClick')
    }
    $('.gnav__list').stop().slideToggle()

    $('.gnav__list').css({
      'top': $('.header').innerHeight(),
    })

    return false
  })

  // TOPへ戻るボタン
  $('.toTop__btn a').on('click', function () {
    var h = $('.header').innerHeight()
    smoothScroll($(this), 300, h)

    return false
  })

  // gnav内のメニュー
  $('.gnav__list a').on('click', function () {
    var h = $('.header').innerHeight()
    smoothScroll($(this), 300, h)

    if (window.matchMedia('(max-width: 900px)').matches) {
      $('.gnav__list').stop().slideToggle()
    }
    $('.gnav__btn a').removeClass('onClick').addClass('removeClick')

    return false
  })

  $(window).on('resize', function () {
    if (!window.matchMedia('(max-width: 900px)').matches) {
      $('.gnav__list').attr('style', '')
      $('.gnav__btn a').removeClass('onClick').addClass('removeClick')
    }
  })

  /***
   * URLに#がある場合の処理
   */
  $(window).on('load', function () {
    $('main').css({
      'margin-top': $('.header').innerHeight(),
    })

    if (window.location.hash) {
      var hh = $('.header').innerHeight()
      var h = hh ? hh : 0

      smoothScroll($(window.location.hash), 1, h)
      return false
    }
  })


  $(window).on('load scroll', function () {
    var scrollY = window.pageYOffset
    if (scrollY < 1000) {
      $('.toTop').removeClass('fadeIn').addClass('fadeOut')
    } else {
      $('.toTop').removeClass('fadeOut').addClass('fadeIn')
    }
  })

  /*---------------------*\
   |                     |
   |    Set Functions    |
   |                     |
  \*---------------------*/
  function smoothScroll($target, $speed, $position) {
    $speed = $speed ? $speed : 500
    $position = $position ? $position : 0

    // アンカーの値取得
    var href = $target.attr("href")
    // console.log( href )

    // hrefが取得できた場合
    if (href !== undefined) {
      href = href.match('#') ? '#' + href.split('#')[1] : ''
    }
    // hrefが取得できた場合
    else {
      href = '#' + $target.attr("id")
    }

    // 移動先を取得
    var target = $(href === "#" || href === "" ? 'html' : href)

    // 移動先を数値で取得
    var offsetTop = target.offset().top
    var position = offsetTop - Math.floor($position)

    // スクロールの速度
    var speed = $speed // ミリ秒

    // スムーススクロール
    $('body,html').animate({scrollTop: position}, speed, 'swing')
  }
})
